export default function validateMemberForm(member) {
  if (!member.Birthdate) {
    return { validated: false, error: "Datum rođenja je obvezan" };
  }

  if (
    !member.Birthdate.match(/\d{4}-\d{2}-\d{2}/g) ||
    new Date(member.Birthdate).toString() === "Invalid Date"
  ) {
    let currentDate = new Date();

    // eslint-disable-next-line prettier/prettier
    let currentDateString = `${currentDate.getFullYear()}-${("0" + (currentDate.getMonth() + 1)).slice(-2)}-${("0" + currentDate.getDate()).slice(-2)}`;

    return {
      validated: false,
      error: `Datum rođenja nije ispravan datum. Ako upisujete ručno pripazite na yyyy-MM-dd (godina, mjesec, dan) način upisivanja: točno tim redoslijedom i koristeći crtice za odvajanje, npr. ${currentDateString}`,
    };
  }

  // Ako je država HR i osoba je starija od 30 dana, OIB je obvezan.
  if (
    member.MailingCountry == "Croatia" &&
    !member?.Tax_Number__c &&
    new Date(member.Birthdate) <
      new Date(new Date().setDate(new Date().getDate() - 30))
  ) {
    return { validated: false, error: "OIB je obvezan" };
  }

  if (member.Tax_Number__c && !isOibValid(member.Tax_Number__c)) {
    return { validated: false, error: "OIB je neispravan" };
  }

  return { validated: true };
}

export function isOibValid(input) {
  const oib = input.toString();

  if (oib.length !== 11 || oib.match(/\d{11}/) === null) {
    return false;
  }

  let calculated = 10;

  for (const digit of oib.substring(0, 10)) {
    calculated += parseInt(digit);

    calculated %= 10;

    if (calculated === 0) {
      calculated = 10;
    }

    calculated *= 2;
    calculated %= 11;
  }

  let check = 11 - calculated;

  if (check === 10) {
    check = 0;
  }

  return check === parseInt(oib[10]);
}
